// extracted by mini-css-extract-plugin
export default {"skeletonWrapper":"resetpasswordskeleton_skeletonWrapper__7wliC"};